import { ButtonIcon, ConditionalLink, Flex } from 'components';

import styled from 'styled-components';

import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.min.css';
import './styles.scss';

SwiperCore.use([Navigation]);

interface TabsProps {
  items: {
    label: string;
    link: string;
  }[];
}

const NavigationButton = styled(ButtonIcon)`
  box-shadow: 0px 0px 20px 0px rgba(220, 224, 222, 1);
  z-index: 10;
  display: flex !important;
  flex-shrink: 0;
`;

// 240, 244, 242

const TabLink = styled(ConditionalLink)`
  display: flex;
  align-items: center;
  height: 55px;
  color: ${({ theme }) => theme.colors.primary_400};
  text-transform: uppercase;
  ${({ theme }) => theme.fontTypes.type1}
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  padding: 0 ${({ theme }) => `${theme.space[4]}px`};

  &.active {
    &::after {
      content: '';
      display: block;
      background: ${({ theme }) => theme.colors.primary_400};
      width: 100%;
      height: 4px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
`;

const Tabs = ({ items }: TabsProps) => {
  return (
    <Flex maxWidth="100vw" flexGrow={0} bg="gray_100" flexWrap="nowrap" overflow="hidden">
      <NavigationButton
        icon="chevronLeft"
        display={{ m: 'none', t: 'flex' }}
        width={{ m: 50, d: 60 }}
        iconWidth={22}
        className="tabs-prev"
        bg="gray_100"
        color="primary_400"
      />

      <Swiper
        navigation={{
          prevEl: '.tabs-prev',
          nextEl: '.tabs-next',
        }}
        slidesPerView="auto"
        spaceBetween={0}
        loop={false}
        className="tabs-pagination"
      >
        {items.map((item, index) => (
          <SwiperSlide key={`tab-item-${index.toString()}`}>
            <TabLink type="internalNav" to={item.link}>
              {item.label}
            </TabLink>
          </SwiperSlide>
        ))}
      </Swiper>

      <NavigationButton
        icon="chevronRight"
        display={{ m: 'none', t: 'flex' }}
        width={{ m: 50, d: 60 }}
        iconWidth={22}
        className="tabs-next"
        bg="gray_100"
        color="primary_400"
        mr={{ m: '12px', d: 0 }}
      />
    </Flex>
  );
};

export default Tabs;

// import { ReactElement } from 'react';
// import { Link } from 'react-router-dom';
// import styled from 'styled-components';

// import SwiperCore, { Navigation } from 'swiper';
// import { Swiper, SwiperSlide } from 'swiper/react';

// import 'swiper/swiper.min.css';
// import './styles.scss';

// import { ButtonIcon, ConditionalLink, Flex } from 'components';
// import { createUrl } from 'app/utils';

// SwiperCore.use([Navigation]);

// interface tabsPaginationProps {
//   examUuid: string;
//   questionUuid: string;
// }

// const TabLink = styled(ConditionalLink)`
//   display: flex;
//   flex-grow: 1;
//   height: 60px;
//   align-items: center;
//   justify-content: center;

//   font-size: ${({ theme }) => theme.fontTypes.type6};
//   font-weight: bold;

//   color: ${(props: any) => {
//     if (props['data-active']) {
//       return `white`;
//     }

//     return props.theme.colors.gray_600;
//   }};

//   &:first-child {
//     padding: 0 15px;
//   }

//   ${({ theme: { mediaQueries } }) => {
//     return `

//       ${mediaQueries.desktop} {

//       }
//     `;
//   }}
// `;

// const tabsPagination = ({ examUuid, questionUuid }: tabsPaginationProps): ReactElement => {
//   return (
//     <>
// <Flex flexGrow={0} bg="dark_350" flexWrap="nowrap">
//   <ButtonIcon
//     icon="chevronLeft"
//     display={{ m: 'none', t: 'flex' }}
//     width={{ t: 60 }}
//     iconWidth={22}
//     className="tabs-prev"
//     bg="transparent"
//   />

//   <Swiper
//     navigation={{
//       prevEl: '.tabs-prev',
//       nextEl: '.tabs-next',
//     }}
//     slidesPerView="auto"
//     spaceBetween={1}
//     loop={false}
//     className="tabs-pagination"
//   >
//     <SwiperSlide>
//       <TabLink
//         data-active={!questionUuid}
//         type="internal"
//         to={createUrl('tabs/start', [examUuid])}
//       >
//         Abertura
//       </TabLink>
//     </SwiperSlide>

//     {Array(25)
//       .fill(null)
//       .map((_, index) => (
//         <SwiperSlide key={`exam-pagination-${index.toString()}`}>
//           <TabLink type="internal" to={createUrl('tabs/question', [examUuid, index])}>
//             {String(index + 1).padStart(2, '0')}
//           </TabLink>
//         </SwiperSlide>
//       ))}
//   </Swiper>

//   <ButtonIcon
//     icon="chevronRight"
//     display={{ m: 'none', t: 'flex' }}
//     width={{ t: 60, d: 79 }}
//     iconWidth={22}
//     className="tabs-next"
//     bg="transparent"
//   />
// </Flex>
//       {examUuid}---
//       {questionUuid}
//     </>
//   );
// };

// export default tabsPagination;
